module.exports = __webpack_public_path__ + "e5e0934dfd7982200e5261169661c78b.pdf";